import * as React from 'react';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { ListItemText } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { DisplayFormInputValue } from '../../../../../interfaces/interfaces';
import { GeneralSourceAndTypeBundle } from '../FileSourceAutocomplete/FileSourceAutocomplete';
import { createURLForUploadHistory } from '../../../../../utils/URLcreators';

interface FileTypeAutocompleteProps {
  value: DisplayFormInputValue | null;
  options: DisplayFormInputValue[] | [];
  searchValue: GeneralSourceAndTypeBundle | DisplayFormInputValue | null;
  placeholder: string;
  name: string;
  routeValue: string;

  setValue(x: DisplayFormInputValue | null): void;

  setOptions(x: DisplayFormInputValue[] | []): void;
}

const FileTypeAutocomplete = ({ value, setValue, options, setOptions, searchValue, placeholder, name, routeValue }: FileTypeAutocompleteProps) => {
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const { getAccessTokenSilently } = useAuth0();

  React.useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const accessToken = await getAccessTokenSilently();
      const data = await fetch(createURLForUploadHistory(routeValue, searchValue?.id), {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }).then((res) => res.json());
      setOptions(data);
      setIsLoading(false);
    };
    if (!searchValue) return;
    fetchData().catch(setError);
    return () => setOptions([]); // eslint-disable-line
  }, [searchValue, getAccessTokenSilently, setOptions, routeValue]);

  if (error) return <pre>{JSON.stringify(error, null, 2)}</pre>;
  return (
    <Autocomplete
      getOptionLabel={(option) => (typeof option === 'string' ? option : option?.name || '')}
      isOptionEqualToValue={(a: DisplayFormInputValue, b: DisplayFormInputValue) => a === b}
      filterOptions={createFilterOptions({
        matchFrom: 'start',
        trim: true,
      })}
      autoComplete
      loading={isLoading}
      includeInputInList
      filterSelectedOptions
      size="small"
      sx={{ width: '100%', bgcolor: '#ffffff', borderRadius: '5px' }}
      value={value}
      onChange={(event: any, newValue: DisplayFormInputValue | null) => {
        setValue(newValue);
      }}
      // inputValue={fileTypeInputValue}
      // onInputChange={(event, newInputValue) => {
      //   setFileTypeInputValue(newInputValue);
      // }}
      options={options}
      renderInput={(params) => <TextField {...params} id="fileType" name={name} required size="small" placeholder={placeholder} fullWidth />}
      renderOption={(props, option) => (
        <li {...props} key={uuidv4()}>
          <ListItemText primary={option.name} />
        </li>
      )}
    />
  );
};

export default FileTypeAutocomplete;
